import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import InputError from "../typography/InputError";

const Wrapper = styled.div`
  width: 100%;
  font-size: ${fontSize.xs};
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  textarea {
    width: 100%;
    min-height: 200px;
    border: 1px solid
      ${({ $hasError }) => ($hasError ? colors.black : colors.border)};
    padding: 12px 10px;
    outline: none;
    box-sizing: border-box;
    resize: vertical;
    caret-color: ${colors.black};
    font-size: ${fontSize.xxs};
    &::placeholder {
      text-transform: uppercase;
      color: #8e8e8e;
    }
  }

  label {
    font-size: ${fontSize.xxs};
  }
`;

function TextArea({ text, value, error, onChange, label }) {
  return (
    <Wrapper $hasError={!!error}>
      {label && <label>{label}</label>}
      <textarea placeholder={`*${text}`} value={value} onChange={onChange} />
      {error && <InputError error={error} />}
    </Wrapper>
  );
}

export default TextArea;
